export default {"src":"/_next/static/media/compliance-verification.63651a7f.svg","height":250,"width":250,"blurWidth":0,"blurHeight":0};